import { PhotoIcon } from "@heroicons/react/24/outline"
import React from "react"
import Files from "react-files"
import { useTranslation } from "react-i18next"
 
export const ImageInputField = (
  (
    {
      label = null,
      onChange = (files) => {},
      onError = (error, file, message) => {},
      required = false,
      className = "",
      containerClassName = "",
      placeholder = "Add image",
      multiple = true,
      // maxFiles = Infinity,
      maxFiles = 20,
      maxFileSize = 5000000,
      minFileSize = 0,
      clickable = true,
      help = null,
    }
  ) => {
    const { i18n } = useTranslation()
    const onErrorHandler = (error, file) => {
      switch (error.code) {
        case 1:
          onError(error, file, i18n.t("imageInputField.not_an_image"))
          break
        case 2:
          onError(
            error,
            file,
            `${i18n.t("imageInputField.max_image")} ${maxFileSize / 1000000}${i18n.t("imageInputField.mb")}`
          )
          break
        case 3:
          onError(
            error,
            file,
            `${i18n.t("imageInputField.min_image")} ${minFileSize / 1000000}${i18n.t("imageInputField.mb")}`
          )
          break
        case 4:
          onError(
            error,
            file,
            `${i18n.t("imageInputField.max_images")} ${maxFiles} ${i18n.t("imageInputField.max_images_text")}`
          )
          break
      }
    }

    return (
      <div className={containerClassName}>
        {label && (
          <label className="block text-sm font-medium text-gray-700">
            {label}
            {required && <span className="text-red-500"> *</span>}
          </label>
        )}
        <div className="mt-1">
          <Files
            className={
              "border-dashed rounded border-2 border-black border-opacity-20 p-5 flex justify-center items-center cursor-pointer" +
              className
            }
            onChange={(files) => onChange(files)}
            onError={(error, file) => onErrorHandler(error, file)}
            accepts={["image/png", "image/jpg", "image/jpeg"]}
            multiple={multiple}
            maxFiles={maxFiles}
            maxFileSize={maxFileSize}
            minFileSize={minFileSize}
            clickable={clickable}
          >
            <PhotoIcon
              className="h-5 w-5 text-gray-400 mr-2"
              aria-hidden="true"
            />
            <span className="text-gray-500">{placeholder}</span>
          </Files>
        </div>
        {help && <div className="italic text-gray-400 mt-1">{help}</div>}
      </div>
    )
  }
)
